import { createI18n } from 'vue-i18n'
import bn from './i18n/bn.json'
import en from './i18n/en.json'
import de from './i18n/de.json'

const DEFAULT_LANG = 'en'

const locales = {
  bn,
  en,
  de,
}
const i18n = createI18n({
  legacy: true,
  locale: DEFAULT_LANG,
  messages: locales,
})

export default i18n
